var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_2104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 21,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24585 4.77881C2.24585 4.38098 2.39636 3.99945 2.66427 3.71815C2.93218 3.43684 3.29554 3.27881 3.67442 3.27881H20.8173C21.1962 3.27881 21.5595 3.43684 21.8274 3.71815C22.0953 3.99945 22.2458 4.38098 22.2458 4.77881C22.2458 5.17663 22.0953 5.55816 21.8274 5.83947C21.5595 6.12077 21.1962 6.27881 20.8173 6.27881H3.67442C3.29554 6.27881 2.93218 6.12077 2.66427 5.83947C2.39636 5.55816 2.24585 5.17663 2.24585 4.77881ZM2.24585 12.2788C2.24585 11.881 2.39636 11.4995 2.66427 11.2181C2.93218 10.9368 3.29554 10.7788 3.67442 10.7788H20.8173C21.1962 10.7788 21.5595 10.9368 21.8274 11.2181C22.0953 11.4995 22.2458 11.881 22.2458 12.2788C22.2458 12.6766 22.0953 13.0582 21.8274 13.3395C21.5595 13.6208 21.1962 13.7788 20.8173 13.7788H3.67442C3.29554 13.7788 2.93218 13.6208 2.66427 13.3395C2.39636 13.0582 2.24585 12.6766 2.24585 12.2788ZM2.24585 19.7788C2.24585 19.381 2.39636 18.9995 2.66427 18.7181C2.93218 18.4368 3.29554 18.2788 3.67442 18.2788H20.8173C21.1962 18.2788 21.5595 18.4368 21.8274 18.7181C22.0953 18.9995 22.2458 19.381 22.2458 19.7788C22.2458 20.1766 22.0953 20.5582 21.8274 20.8395C21.5595 21.1208 21.1962 21.2788 20.8173 21.2788H3.67442C3.29554 21.2788 2.93218 21.1208 2.66427 20.8395C2.39636 20.5582 2.24585 20.1766 2.24585 19.7788Z",
    fill: "#1F2024"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_2104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.24585,
    y: 0.278809,
    width: 24,
    height: 24,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventActive);
export default __webpack_public_path__ + "static/media/eventActive.b7a72249cebf02c638d48804a351c068.svg";
export { ForwardRef as ReactComponent };